import * as yup from 'yup';

export const roleSchema = yup.object().shape({
    project_name: yup.object().nullable().required('Project is required'), // Changed to object for react-select
    audition_type: yup.array().min(1, 'At least one Audition Type is required').required('Audition Type is required'),
    role_category: yup.array().min(1, 'At least one Category is required').required('Category is required'),
    gender: yup.array().min(1, 'At least one Gender is required').required('Gender is required'),
    talent: yup.array().min(1, 'At least one Talent is required').required('Talent is required'),
    status: yup.object().shape({
        value: yup.string().required('Status is required'), // Validate the 'value' property within the object
        label: yup.string().required(),
    }).nullable().required('Status is required'), // Ensure the object itself is required
    special_category: yup.object().shape({
        value: yup.string().nullable(), // Validate the 'value' property within the object
        label: yup.string().nullable(),
    }).nullable(),
    
    role_name: yup.string().required('Role Name is required'),
    role_description: yup.string().nullable(),
    story_line: yup.string().nullable(),
    character_sketch: yup.string().nullable(),
    script_details: yup.string().nullable(),
    scene_details: yup.string().nullable(),

    metaTitle: yup.string().nullable(),
    metaKeywords: yup.string().nullable(),
    metaDescription: yup.string().nullable(),

    auditionLocations: yup.array().of(yup.object().shape({
        pincode: yup.string().nullable().matches(/^\d{6}$/, 'Pincode must be 6 digits'),
        address1: yup.string().required('Address is required'),
        state: yup.string().nullable(),
        district: yup.string().nullable(),
    })).min(1, 'At least one Audition Location is required'), // Ensure at least one location
    
    // Schedule specific fields (these are watched, not directly validated by schema submission)
    language: yup.array().nullable(), // These should be .nullable() to avoid min(1) if not required
    nationality: yup.array().nullable(),
    age_year: yup.array().nullable(),
    hair_color: yup.array().nullable(),
    body_type: yup.array().nullable(),
    height_ft: yup.array().nullable(),
    eye_color: yup.array().nullable(),
    chest_size:yup.array().nullable(),
    waist_size:yup.array().nullable(),
    // special_category:yup.array().nullable(),
    start_date: yup.date().nullable(),
    end_date: yup.date().nullable(),
    start_time: yup.date().nullable(),
    end_time: yup.date().nullable(),
    casting_time: yup.object().nullable(),
    week_days_off: yup.array().nullable(),
    online_seats_per_day_input: yup.number().nullable().min(0, 'Cannot be negative').integer('Must be a whole number'),
    casting_location: yup.object().nullable(),
});